export default "__VITE_ASSET__B1fnV5WL__"